<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <h1 class="govuk-heading-xl">Optional Add-ons</h1>

            <ng-container *ngIf="addOns.length > 0; else noAddOns">
              <table class="govuk-table">
                  <caption class="govuk-visually-hidden">Your add-ons</caption>
                  <thead class="govuk-table__head">
                      <tr class="govuk-table__row">
                          <th scope="col" class="govuk-table__header" style="width: 50%">Item</th>
                          <th scope="col" class="govuk-table__header" aria-hidden="true">&nbsp;</th>
                          <th scope="col" class="govuk-table__header" style="width:20%">Quantity</th>
                      </tr>
                  </thead>
                  <tbody class="govuk-table__body">
                      <tr class="govuk-table__row" *ngFor="let row of addOns">
                          <td class="govuk-table__cell" style="width: 50%">{{ row.item }}</td>
                          <td class="govuk-table__cell">&nbsp;</td>
                          <td class="govuk-table__cell">{{ row.quantity }}</td>
                      </tr>
                  </tbody>
              </table>
            </ng-container>

            <ng-template #noAddOns>
                <p class="govuk-body">You have not added any add-ons to your ceremony.</p>
            </ng-template>

                  <div class="row amend-buttons-wrapper">
                    <div class="col-12 amend-buttons flex-wrap gap-3">
                        <button type="button" class="btn btn-primary" data-module="govuk-button" (click)="navigate('/add-ons/before-you-start')">
                            Add ons
                        </button>
                    </div>
                </div>
        </main>
    </div>
</div>
